import React from 'react';
import { Pressable } from 'native-base';
import { SpIcon } from '~/shared/Icon';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { ProductListPageProps, useDutchieStore, useI18n, useTheme } from '@springbig/shared';
import { useAppNavigate } from '~/pages';
import { Input } from '~/shared/Theme';

export const SearchBar = () => {

    const { primary } = useTheme();

    const {
        retailer,
        setProductListProps,
        isBusy,
    } = useDutchieStore();

    const { navigate, params } = useAppNavigate();
    const { t } = useI18n();

    const [searchValue, setSearchValue] = React.useState('');
    const handleChange = (text: string): void => setSearchValue(text);
    const onSubmitSearch = (): void => {

        const productListProps: ProductListPageProps = {
            title: searchValue,
            search: searchValue,
        };
        setSearchValue('');
        setProductListProps(productListProps);
        navigate(`w/${params.wallet_id}/shop/product_list`);
    };

    const onHandleKeyPress = (event): void => {

        if (event.nativeEvent.key === 'Enter') {

            onSubmitSearch();
        }
    };

    return (
        <Input
            placeholder={`${t('shop.search')} ${retailer?.name}`}
            w={'100%'}
            value={searchValue}
            onChangeText={handleChange}
            onKeyPress={onHandleKeyPress}
            rightElement={
                <Pressable
                    px={2}
                    isDisabled={isBusy}
                    onPress={onSubmitSearch}
                >
                    <SpIcon
                        size={20}
                        color={primary}
                        icon={faSearch}
                    />
                </Pressable>
            }
        />
    );
};
